import { c as _c } from "react/compiler-runtime";
import { startTransition, useActionState } from "react";
import { isLocalOrDemo } from "@/env-variables/envHelpers";
import { useMockOppdaterNarmesteLederAction } from "@/mocks/useMockOppdaterNarmesteLederAction";
import type { NarmesteLederForm } from "@/schemas/nærmestelederFormSchema";
import { oppdaterNarmesteLeder } from "@/server/actions/oppdaterNarmesteLeder";
import type { ErrorDetail } from "@/server/narmesteLederErrorUtils";
const initialState = {
  error: null as ErrorDetail | null
};
const action = async (_prev: typeof initialState, {
  behovId,
  values,
  onSuccess,
  onSettled
}: {
  behovId: string;
  values: NarmesteLederForm;
  onSuccess?: () => void;
  onSettled?: (state: typeof initialState) => void;
}) => {
  const result = await oppdaterNarmesteLeder(behovId, values);
  const nextState = {
    error: result.success ? null : result.errorDetail
  };
  if (result.success) onSuccess?.();
  onSettled?.(nextState);
  return nextState;
};
const useRealBehovAction = () => {
  const $ = _c(4);
  const [t0, runAction, isPending] = useActionState(action, initialState);
  const {
    error
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = (behovId, values, options) => new Promise(resolve => {
      startTransition(() => runAction({
        behovId,
        values,
        onSuccess: options?.onSuccess,
        onSettled: resolve
      }));
    });
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const startOppdaterNarmesteLeder = t1;
  let t2;
  if ($[1] !== error || $[2] !== isPending) {
    t2 = {
      startOppdaterNarmesteLeder,
      isPending,
      error
    };
    $[1] = error;
    $[2] = isPending;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2 as const;
};
export const useBehovAction = isLocalOrDemo ? useMockOppdaterNarmesteLederAction : useRealBehovAction;